import React from 'react';
import FormOverviewSection from './overview/FormOverviewSection';
import FormFieldsSection from './fields/FormFieldsSection';
import FormAutomationsSection from './automations/FormAutomationsSection';
import AssetsSection from './assets/AssetsSection';
import FormCreatedSuccessCallout from './FormCreatedSuccessCallout';
import FormReadinessSummary from './FormReadinessSummary';
import FormSetupProgress from './FormSetupProgress';
import useFormSetupProgress from '../hooks/useFormSetupProgress';

export default function FormStudioSectionContent({
  activeSection,
  studio,
  workspaceId,
  formId,
  hasFormId = false,
  showCreateSuccess = false,
  onDismissCreateSuccess,
  onCreateSuccessAddFields,
  onSectionChange,
}) {
  const setupProgress = useFormSetupProgress({
    formId,
    hasFormId,
    fields: studio?.form?.leads_form_items,
    activeSection,
    enabled: hasFormId,
  });

  const handleGoToFields = () => {
    onSectionChange?.('fields');
  };

  const handleGoToAutomations = () => {
    onSectionChange?.('automations');
  };

  return (
    <>
      <FormSetupProgress setupProgress={setupProgress} />

      {showCreateSuccess && activeSection === 'overview' ? (
        <FormCreatedSuccessCallout
          formName={studio.form?.leads_form_name}
          onAddFields={onCreateSuccessAddFields}
          onDismiss={onDismissCreateSuccess}
        />
      ) : null}

      <FormReadinessSummary
        studio={studio}
        hasFormId={hasFormId}
        setupProgress={setupProgress}
        onGoToFields={handleGoToFields}
        onGoToAutomations={handleGoToAutomations}
      />

      {activeSection === 'overview' ? <FormOverviewSection studio={studio} /> : null}
      {activeSection === 'fields' ? (
        <FormFieldsSection
          studio={studio}
          workspaceId={workspaceId}
          hasFormId={hasFormId}
        />
      ) : null}
      {activeSection === 'automations' ? (
        <FormAutomationsSection
          formId={formId}
          workspaceId={workspaceId}
          hasFormId={hasFormId}
          formFields={studio.form?.leads_form_items}
          onGoToFields={handleGoToFields}
        />
      ) : null}
      {activeSection === 'assets' ? (
        <AssetsSection studio={studio} formId={formId} hasFormId={hasFormId} />
      ) : null}
    </>
  );
}
